
__webpack_require__.svgSprite = function(id) {
    return "/static/svg/sprite.93805ce6.svg#" + id;
};
          